// latest: zhangmyh 2017-10-12 3:58 PM
// 已经存在的物资分类
import { Collection, Get, URLs } from 'common'
import { findIndex } from 'lodash'
import 'collection/materialClass'
import './index.less'
/* global $ ko u */

/* eslint-disable */
let _config
/* eslint-enable */
function init (refer) {
  let curLevel = -1
  let collection = Collection.create('materialclass.infolist')
  let selectedSingleData = null
  let pidId;
  const select = (data) => {
    if (_config.multiSelect) {
      let list = vm.selectedData()
      let idx = findIndex(list, ['id', data.id.value])
      if (idx <= -1) {
        vm.selectedData.push({
          id: data.id.value,
          name: data.name.value,
          code: data.code.value,
          fullpath: data.fullpath.value,
          innercode: data.innercode.value
        })
      }
    } else {
      selectedSingleData = {
        id: data.id.value,
        name: data.name.value,
        code: data.code.value,
        fullpath: data.fullpath.value,
        innercode: data.innercode.value
      }
      refer.submit()
    }
  }
  const addTitle = (data) => {
    vm.titleData.push({
      id: data.id.value,
      name: data.name.value,
      level: curLevel
    })
  }
  const spliceTitle = (index) => {
    vm.titleData.splice(index + 1)
  }
  const getChildren = async function (data, index) {
    let id
    if (data === 0) {
      id = 0
    } else if (index) {
      id = data.id
    } else {
      id = data.id.value
    }
    pidId = id;
    let list = await Get(URLs.mc_getclass1.url, {
      pid: id,
      entid: window.global.user.PURCHASEID
    })
    if (list.length > 0) {
      if (data === 0) {
      } else if (index) {
        spliceTitle(index())
        curLevel = data.level + 1
      } else {
        addTitle(data)
        curLevel++
      }
      collection.load({}, { localData: { result: list } })
    } else {
      select(data)
    }
  }

  getChildren(0)

  let vm = {
    getChildren,
    id: ko.observable(),
    key: ko.observable(''),
    remove (id) {
      let list = vm.selectedData()
      let idx = findIndex(list, ['id', id])
      if (idx >= 0) {
        vm.selectedData.splice(idx, 1)
      }
    },
    async search () {
    //  vm.titleData([
    //    { name: `${vm.key()}的搜索结果`, level: -1 }
    //  ])
      let list = await Get(URLs.mc_getclass1.url, {
        pid: pidId,
        keyword: vm.key(),
        entid: window.global.user.PURCHASEID
      })
      collection.load({}, { localData: { result: list } })
    },
    selectedData: ko.observableArray([]),
    titleData: ko.observableArray([
      { name: '顶级类别', level: -1 }
    ]),
    gridconfig: {
      id: 'mtrc_grid',
      data: collection,
      type: 'grid',
      multiSelect: false,
      editable: false,
      pagination: false,
      sortable: false,
      fields: [{
        field: 'name',
        dataType: 'String',
        title: '类别名称',
        width: '39%'
      }, {
        field: 'fullpath',
        dataType: 'String',
        title: '类别层级',
        width: '60%'
      }]
    }
  }
  let app = u.createApp()
  app.init(vm, $('#mtrc_refer')[0])

  // 提交事件
  refer.registerSubmitFunc(() => {
    if (_config.multiSelect) {
      return vm.selectedData()
    } else {
      return selectedSingleData
    }
  })
  collection.datatable.on('select', function (obj) {
    let selectData = collection.datatable.getCurrentRow().data
    getChildren(selectData)
    /* if (selectData.isEnd.value) {
      select(selectData)
    } else {
      getChildren(selectData)
    } */
  })
}

let template = require('./index.html')
export default function (config) {
  _config = Object.assign({
    model: null,
    multiSelect: true,
  }, config)

  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/materialClass/all/index.js